import { Layout } from 'antd';
import * as React from 'react';
import type { ReactNode } from 'react';
import { ThemeProvider } from '../providers/theme-provider';
import { ConnectionProvider } from '../providers/connection-provider';

const { Content } = Layout;

export const EmptyLayout = ({ children }: { children: ReactNode }) => {
  return (
    <ConnectionProvider>
      <ThemeProvider>
        <Layout className="v-grid main" style={{ height: '100vh' }}>
          <Content className="v-grid">{children}</Content>
        </Layout>
      </ThemeProvider>
    </ConnectionProvider>
  );
};
